// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2c0Lk","title":"AfterImages45_title__1gahG","images":"AfterImages45_images__21bA0"};